import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LocaleService } from './locale.service';

@Injectable({
  providedIn: 'root'
})
export class CollectiveService {

  constructor(
    private http: HttpClient,
    private localeService: LocaleService,
  ) {
  }

  getPublicData(): Promise<any> {
    let serviceUrl = `${environment.apiUrl}/${environment.apiVersion}/public/collective/${environment.apiKey}?l=${this.localeService.getLocale()}`;

    return new Promise((resolve, reject) => {
      this.http.get(serviceUrl)
      .subscribe(
        (data: any) => {
          if (data && data['code'] == 200 && data['data'] &&
              (data['data'].active === 0 || data['data'].active === 1)) {
            resolve(data['data']);
            return;
          }

          const responseCode = data && data['code'] !== undefined ? data['code'] : 'unknown';
          const error = new Error(`Invalid collective public data response (code: ${responseCode})`);
          console.error('Could not load collective public data.', error);
          reject(error);
        },
        error => {
          console.error('Could not load collective public data.', error);
          reject(error);
        }
      );
    });
  }
}
